@if (mainFormGroup) {
    <div class="card">
        <div class="card-body" [formGroup]="mainFormGroup">
            <h5 class="card-title">{{ 'kri.cardTitle' | t }}</h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>

            <div class="form-group">
                <label>{{ 'kri.startDate' | t }}</label>
                <date-input
                    #startDateComponent
                    formControlName="startDate"
                    [maxDate]="endDate"
                ></date-input>
            </div>

            <div class="form-group">
                <label>{{ 'kri.endDate' | t }}</label>
                <date-input
                    #endDateComponent
                    formControlName="endDate"
                    [minDate]="startDate"
                ></date-input>
            </div>
            <hr />
            <button class="btn btn-default me-2 mb-2" (click)="exportKriDataPoints()">
                {{ 'kri.exportButton' | t }}
            </button>
        </div>
    </div>
}
